import { render } from "./shop-teacher-dialog.vue?vue&type=template&id=3b8018e8&scoped=true"
import script from "./shop-teacher-dialog.vue?vue&type=script&lang=js"
export * from "./shop-teacher-dialog.vue?vue&type=script&lang=js"

import "./shop-teacher-dialog.vue?vue&type=style&index=0&id=3b8018e8&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8018e8"]])

export default __exports__